import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
/* eslint-disable react/static-property-placement */

import * as React from 'react';
import classnames from 'classnames';
import ReactHTMLParser from 'react-html-parser';
import { Analytics, AnalyticsLocationConsumer, getTrackingQueryString, trackEvent } from 'latitude-analytics';
import { Link } from '@latitude/link';
import './_login-form.scss';

var CardTypeLinkDivider = function CardTypeLinkDivider() {
  return /*#__PURE__*/React.createElement("div", {
    className: "static-text",
    style: {
      margin: '0 0.7rem'
    }
  }, "or");
};

var LoginForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleCardSelectChange = function (event, analytics, location) {
      var cardTypes = _this.props.cardTypes;
      var selectedItemTextValue = event.target.options[event.target.selectedIndex].text;

      _this.setState({
        selectedCard: cardTypes.filter(function (card) {
          return card.id === event.currentTarget.value;
        })[0]
      });

      trackEvent(analytics, {
        category: 'drop-down',
        action: 'in-page-navigation',
        label: selectedItemTextValue,
        location: location
      });
    };

    _this.handleClick = function (ev) {
      if (!_this.props.isOpen) return;
      var clickTarget = ev.target;
      var wrapperNode = _this.wrapperRef && _this.wrapperRef.current;
      var openElement = _this.props.openElement;

      if (wrapperNode && clickTarget instanceof Node && !wrapperNode.contains(clickTarget) && (!openElement || !openElement.contains(clickTarget))) {
        _this.props.onRequestClose();
      }
    };

    _this.handleKeyDown = function (event) {
      if (!_this.props.isOpen) return;

      if (event.keyCode === 27) {
        _this.props.onRequestClose();
      }
    };

    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this)); // selected card is null by default

    _this.state = {
      selectedCard: null
    };
    return _this;
  }

  var _proto = LoginForm.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('keydown', this.handleKeyDown, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
    document.removeEventListener('mousedown', this.handleClick, false);
  };

  _proto.getSelectedCardName = function getSelectedCardName(cardId) {
    var selectedCardType = this.props.cardTypes.find(function (cardType) {
      return cardType.id === cardId;
    });
    return selectedCardType ? selectedCardType.name : null;
  }
  /**
   * Handles selection and tracking of credit card type from drop-down box
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var analytics = this.props.analytics;
    var selectedCard = this.state.selectedCard;
    var selectedCardName = selectedCard ? this.getSelectedCardName(selectedCard.id) : null; // work out links url

    var selectedCardLoginUrl = selectedCard && selectedCard.login && selectedCard.login.url;
    var selectedCardUploadUrl = selectedCard && selectedCard.upload && selectedCard.upload.url;
    var selectedCardRegisterUrl = selectedCard && selectedCard.register && selectedCard.register.url; // work out links hrefs

    var selectedCardLoginHref = selectedCardLoginUrl ? "" + selectedCardLoginUrl + getTrackingQueryString(analytics, {
      text: 'Login',
      location: 'login-popup',
      context: selectedCardName
    }) : null;
    var selectedCardUploadHref = selectedCardUploadUrl ? "" + selectedCardUploadUrl + getTrackingQueryString(analytics, {
      text: 'Upload',
      location: 'login-popup',
      context: selectedCardName
    }) : null;
    var selectedCardRegisterHref = selectedCardRegisterUrl ? "" + selectedCardRegisterUrl + getTrackingQueryString(analytics, {
      text: 'Register',
      location: 'login-popup',
      context: selectedCardName
    }) : null; // work out links targets

    var selectedCardLoginTarget = selectedCard && selectedCard.login && selectedCard.login.target || null;
    var selectedCardUploadTarget = selectedCard && selectedCard.upload && selectedCard.upload.target || null;
    var selectedCardRegisterTarget = selectedCard && selectedCard.register && selectedCard.register.target || null;
    return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
      return /*#__PURE__*/React.createElement("div", {
        ref: _this2.wrapperRef,
        className: classnames('login-form', _this2.props.className, _this2.props.isOpen ? 'login-form--is-open' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "row existing-customer"
      }, /*#__PURE__*/React.createElement("section", {
        className: "col-12 col-md-6 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.creditCardsPaneTitle || 'Credit Cards')), /*#__PURE__*/React.createElement("select", {
        className: "styled-select"
        /* js-siteHeader__personalised-link__select */
        ,
        id: "form-card-login__card",
        onChange: function onChange(event) {
          return _this2.handleCardSelectChange(event, analytics, location);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, ReactHTMLParser(_this2.props.loginForm.creditCardsSelectDefaultText || 'Select a card')), _this2.props.cardTypes.map(function (card) {
        return /*#__PURE__*/React.createElement("option", {
          key: card.id,
          value: card.id
        }, card.name);
      })), _this2.state.selectedCard && /*#__PURE__*/React.createElement("div", {
        className: "personalised-links"
      }, !!selectedCardLoginHref && /*#__PURE__*/React.createElement(Link, {
        "data-trackid": "nav--login",
        className: "trackcustomanalytics",
        href: selectedCardLoginHref,
        target: selectedCardLoginTarget,
        trackEventData: {
          action: 'service-centre-link',
          location: location
        }
      }, _this2.props.loginForm.creditCardsLoginLinkText || 'Login'), !!selectedCardUploadHref && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardTypeLinkDivider, null), /*#__PURE__*/React.createElement(Link, {
        "data-trackid": "nav--upload",
        className: "trackcustomanalytics",
        href: selectedCardUploadHref,
        target: selectedCardUploadTarget,
        trackEventData: {
          location: location
        }
      }, _this2.props.loginForm.creditCardsUploadLinkText || 'Upload&nbsp;documents')), !!selectedCardRegisterHref && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardTypeLinkDivider, null), /*#__PURE__*/React.createElement(Link, {
        "data-trackid": "nav--register",
        className: "trackcustomanalytics",
        href: selectedCardRegisterHref,
        target: selectedCardRegisterTarget,
        trackEventData: {
          action: 'service-centre-link',
          location: location
        }
      }, _this2.props.loginForm.creditCardsRegisterLinkText || 'Register'))))), /*#__PURE__*/React.createElement("section", {
        className: "col-12 col-md-6 existing-customer__section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-form__panel"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text--bold"
      }, ReactHTMLParser(_this2.props.loginForm.loansPaneTitle || 'Loans')), /*#__PURE__*/React.createElement("p", {
        className: "static-text"
      }, ReactHTMLParser(_this2.props.loginForm.loansPaneIntro || 'Login to continue your application, upload documents, or accept contracts.')), /*#__PURE__*/React.createElement(Link, {
        className: "opzttag148825656loans",
        href: _this2.props.loginForm.loansLoginLinkUrl || '',
        trackEventData: {
          location: location
        }
      }, _this2.props.loginForm.loansLoginLinkText || 'Login to Loan Applications')))));
    });
  };

  return LoginForm;
}(React.Component);

LoginForm.defaultProps = {
  isStickyOpen: false // eslint-disable-line react/default-props-match-prop-types

};
export default LoginForm;